import { useEffect } from 'react';

/**
 * Injeta um ou mais blocos JSON-LD no <head> e os remove ao desmontar.
 *
 * Existe pela mesma razão do `usePageMeta`: o `react-helmet-async` não
 * renderiza nada neste projeto com React 19, então o JSON-LD declarado dentro
 * do <Helmet> nas páginas antigas nunca chegou ao DOM. Aqui a inserção é
 * direta e determinística.
 *
 * Cada bloco recebe um `data-jsonld` para que a limpeza remova exatamente o
 * que esta página criou, sem tocar no JSON-LD estático do index.html.
 */
export const useJsonLd = (blocos: unknown[], id: string) => {
    useEffect(() => {
        const criados = blocos.map((bloco) => {
            const el = document.createElement('script');
            el.type = 'application/ld+json';
            el.setAttribute('data-jsonld', id);
            el.textContent = JSON.stringify(bloco);
            document.head.appendChild(el);
            return el;
        });

        return () => criados.forEach((el) => el.remove());
        // `blocos` é remontado a cada render; a identidade da página é o `id`.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);
};
